<template>
  <div>
    <img
      src="@/assets/images/line/Frame 1000002302.png"
      alt="lineimg"
      class="m-auto mob-hidden"
    />
    <div
      class="w-full md:py-0 lg:py-0 py-10 flex justify-between md:relative lg:relative"
      id="joindonor"
    >
      <div class="absolute bg-design11 md:block lg:block hidden">
        <img
          src="../../../assets/images/bg-des/JU-donate-bg-t.svg"
          alt="bg-polygon"
          class=""
        />
      </div>
      <div class="absolute bg-design12 md:block lg:block hidden">
        <img
          src="../../../assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>

      <div class="flex flex-wrap sm-fiximg w-full items-center">
        <div class="lg:w-1/2 md:w-1/2 w-full lg:pr-20 md:pr-10">
          <div class="lg:pt-0 md:pt-0 pt-3">
            <p class="title-semibold fsize36-24px">
              Commitment and passion are what drives us
            </p>
            <p class="joinus-subtitle md:pt-10 lg:pt-10 pt-4 fsize24-14px">
              We are always looking for young and enthusiastic individual who
              wish to learn, challenge themselves and have the desire to make an
              impact in the social sector. If you are committed to the cause and
              believe you can make a difference, we are happy to welcome you to
              our team.
            </p>
            <div class="md:pt-10 lg:pt-10 pt-6">
              <!-- <a
              href="https://pages.razorpay.com/caregiversaathi-donation"
              alt="link"
              target="_blank"
            >
            </a> -->
              <base-button
                type="primary"
                class="md:px-10 lg:px-10 px-6 md:py-2 lg:py-2 py-1 font-semibold border-2 fsize18px"
                @click="handleRoute('request-form', 'work-at-cgs')"
              >
                <!-- <a
                  target="_blank"
                  class="hover:text-white"
                  href="https://forms.office.com/r/Nq2ACSFPFu "
                  > -->
                Employee
                <!-- </a> -->
              </base-button>
              <!--  @click="handleClick('donate')" -->
            </div>
          </div>
        </div>
        <!-- @click="handleClick('donate')" -->
        <div class="lg:w-1/2 md:w-1/2 w-full h-full flex items-center">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Cg-img/Partnerwithus-employee.jpg"
            alt=""
            class="mr-auto custborderradius contactus-short-w650px sm-mauto alignimg-aboutus md:block lg:block"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
      this.toggleNavbar();
    },
    handleRoute(name) {
      this.$router.push({
        name: name,
        params: {
          pathName: route,
        },
      });
    },
  },
};
</script>
